import {Component, Input, OnInit} from '@angular/core';
import {Line} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-line-status',
  templateUrl: './line-status.component.html',
  styleUrls: ['./line-status.component.css']
})


export class LineStatusComponent implements OnInit {
  @Input()
  line: Line = new Line();
  itemValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(value:VariableValue): string
  {
    return sprintf("%5.1f", value.val / 1);
  }

  ngOnInit(): void {
    this.itemValue = this.variableDB.AddValueByReference(this.line.variable.id);
  }

  ValueAsText(value:VariableValue): string
  {
    if(value.val < 0)
      return "invalid";
    return this.line.textvalues[value.val].text;

  }

  TransformValue(value:VariableValue): number
  {
    if(value.val < 0)
      return -1;
    return this.line.textvalues[value.val].value;
  }

// {{ line.status.textvalues[value.value].value  }} ==  {{ line.status.textvalues[value.value].text }}
}
